export function getBaseDialogModalStyle(theme) {
    return {
        main: {
            // Examples of theme based styling below.
            background: theme.customSemanticColors.solidBackgroundBase,
            borderRadius: "6px",
            color: theme.customSemanticColors.textPrimary,
            // Arbitrary width: 50% style here for now to demonstrate that this style is
            // overridden in Dialog.tsx by style applied via props and merged with
            // concatStyleSets.
            width: "50%",
        },
    };
}
export function getModalCloseButtonStyle(theme) {
    return {
        root: {
            "::before": {
                content: "",
            },
            // Styles needed to adjust our app-wide focus-visual to inset to show within the dialog close
            // button at the edge of the dialog, such that it isn't cutoff at the edge.
            ":focus-visible": {
                boxShadow: "0 0 0 2px " + theme.customSemanticColors.focusOuter + " inset",
            },
            background: "transparent",
            position: "absolute",
            right: "0px",
            top: "0px",
        },
        rootHovered: {
            "::before": {
                content: "",
            },
            background: theme.customSemanticColors.subtleFillSecondary,
        },
        rootPressed: {
            "::before": {
                content: "",
            },
            background: theme.customSemanticColors.subtleFillTertiary,
        },
    };
}
export function getModalCloseButtonIconStyle() {
    return {
        root: {
            fontSize: "10px",
        },
    };
}
export function getModalDialogContentStyle() {
    return {
        root: {
            padding: "40px 36px 30px 36px",
        },
    };
}
